import { createSlice } from '@reduxjs/toolkit';
import { sendGeneralRequest} from '../generalRequest';

const initialState = {
    phone: '',
    token: '',
    currentRegistrationStep: -1,
    shouldEmailAnimationPlay: false,
    isOtpSuccessfullyResent: false,
    shouldRepeatEmailRequest: true,
    isEmailSuccessfullyResent: false,
    shouldFourthStepBeSkipped: false, 
    idExpiryDate: '',
    accountType: '',
    idNumber:'',
    uploadedImage: '',
    idPictureBase64: '',
    idPictureExtension:'',
    isLoading: false,
    fathersName: '',
    isRegistrationFinished: false,
    fullName:'',
    city: '',
    address: '',
    birthDate: '',
    gender: '',
    isUpgrading : false,
    isValidatingPhone: false,
    isValidatingEmail: false,
    isPickingIndividualOrExpressAccountType: false,
    prefix: '',
    isForeignNumber: false,
    otp: '',
    shouldFacePhiApply: false,
    nationality: '',
    bestSelphiImage: '',
    docNumber: '',
    countryCode: '',
    bestImageTokenized: '',

};

export const registrationSlice = createSlice({
    name: 'registration',
    initialState,
    reducers:{
        setFullName : (state, action) => {
            state.fullName = action.payload
        },
        setFathersName : (state, action) => {
            state.fathersName = action.payload
        },
        setBusinessName : (state, action) => {
            state.businessName = action.payload
        },
        setIsPickingIndividualOrExpressAccountType: (state, action) => {
            state.isPickingIndividualOrExpressAccountType = action.payload
        },
        setIsEmailSuccessfullyResent : (state, action) => {
            state.isEmailSuccessfullyResent = action.payload
        },
        setPrefix : (state, action) => {
            state.prefix = action.payload
        },
        setIsUpgrading : (state, action) => {
            state.isUpgrading = action.payload
        },
        setAccountType : (state, action) => {
            state.accountType = action.payload
        },
        setCity : (state, action) => {
            state.city = action.payload
        },
        setAddress : (state, action) => {
            state.address = action.payload
        },
        setBirthdate : (state, action) => {
            state.birthDate = action.payload
        },
        setGender : (state, action) => {
            state.gender = action.payload
        },
        setPhone : (state, action) => {
            state.phone = action.payload
        },
        setIsOtpSuccessfullyResent : (state, action) => {
            state.isOtpSuccessfullyResent = action.payload
        },
        incrementCurrentRegistrationStep : (state) => {
            state.currentRegistrationStep = state.currentRegistrationStep + 1
        },
        setCurrentRegistrationStep : (state, action) => {
            state.currentRegistrationStep = action.payload
        },
        decrementCurrentRegistrationStep : (state) => {
            state.currentRegistrationStep = state.currentRegistrationStep - 1
        },
        setIdExpiryDate: (state, action) => 
        {
            state.idExpiryDate = action.payload
        },
        setUploadedImage: (state, action) => 
        {
            state.uploadedImage = action.payload
        },
        setIdNumber: (state, action) => 
        {
            state.idNumber = action.payload
        },
        setIdPictureBase64: (state, action) => 
        {
            state.idPictureBase64 = action.payload
        },
        setIdPictureExtension: (state, action) => 
        {
            state.idPictureExtension = action.payload
        },
        setShouldFourthStepBeSkipped: (state, action) => 
        {
            state.shouldFourthStepBeSkipped = action.payload
        },
        setIsValidatingPhone : (state, action) => {
            state.isValidatingPhone = action.payload
        },
        setIsValidatingEmail : (state, action) => {
            state.isValidatingEmail = action.payload
        },
        setRegistrationToken : (state, action) => 
        {
            state.token = action.payload
        },
        setIsForeignNumber : (state, action) => 
        {
            state.isForeignNumber = action.payload
        },
        setShouldFacePhiApply : (state, action) =>
        {
            state.shouldFacePhiApply = action.payload
        },
        setNationality : (state, action) => 
        {
            state.nationality = action.payload
        },
        setBestSelphiImage : (state, action) => 
        {
            state.bestSelphiImage = action.payload
        },
        setDocNumber : (state, action) =>
        {
            state.docNumber = action.payload
        },
        setCountryCode : (state, action) =>
        {
            state.countryCode = action.payload
        },
        setBestImageTokenized : (state, action) => 
        {
            state.bestImageTokenized = action.payload
        },
        resetRegistrationState: () => initialState 
        
    },
    extraReducers: (builder) => {
        builder
            .addCase(sendGeneralRequest.pending, (state) => {
                state.isLoading = true
            }) 
            .addCase(sendGeneralRequest.rejected, (state) => {
                state.isLoading = false
            }) 
            .addCase(sendGeneralRequest.fulfilled, (state, action) => {
                state.isLoading = false
                if(action.payload.endpoint === 'RegisterNew')
                {
                    state.token = action.payload.response.token
                    state.otp = action.payload.response.pinOTP
                    state.currentRegistrationStep = state.currentRegistrationStep + 1                      
                }
                else if(action.payload.endpoint === 'ValidateOtp')
                {
                    state.currentRegistrationStep = state.currentRegistrationStep + 1   
                }
                else if(action.payload.endpoint === 'ValidatePhone')
                {
                    state.otp = action.payload.response.pinOTP
                    state.isOtpSuccessfullyResent = true 
                }
                else if(action.payload.endpoint === 'SendConfirmationLink')
                {
                    state.isEmailSuccessfullyResent = true 
                }
                /*else if(action.payload.endpoint === 'ResendOTPGeneric')
                {            
                    state.isOtpSuccessfullyResent = true    
                }*/
                else if(action.payload.endpoint === 'CheckEmailValidation')
                {      
                    state.shouldEmailAnimationPlay = true
                    state.shouldRepeatEmailRequest = false              
                }
                else if(action.payload.endpoint === 'UpdateUserDataNew')
                {  
                    state.isRegistrationFinished = true        
                }
                else if(action.payload.endpoint === 'UpgradeFromBasicToIPEIndividual')
                {  
                    state.isRegistrationFinished = true        
                }
            })
    },
})
export const { incrementCurrentRegistrationStep, setCurrentRegistrationStep, setIsPickingIndividualOrExpressAccountType,setIsEmailSuccessfullyResent, setPhone, setIsUpgrading, setAccountType,setIsOtpSuccessfullyResent, setIdExpiryDate, setIdNumber, setIdPictureBase64, setIdPictureExtension, setUploadedImage, decrementCurrentRegistrationStep, setAddress, setBirthdate, setCity, setFullName, setGender, resetRegistrationState, setShouldFourthStepBeSkipped, setFathersName, setRegistrationToken, setBusinessName, setIsValidatingPhone, setIsValidatingEmail, setPrefix, setIsForeignNumber, setShouldFacePhiApply, setNationality, setBestSelphiImage, setDocNumber, setCountryCode, setBestImageTokenized } = registrationSlice.actions;

export const selectRegistrationState = (state) => state.registration;

export default registrationSlice.reducer;

